const header = {
  kubLogoLight: require('../../assets/img/logo/kubulus-logo-hell.svg'),
  kubLogoDark: require('../../assets/img/logo/kubulus-logo-dunkel.svg')
}

export default {
  header
}
